export const SUCCESS = 'success'
export const ERROR = 'error'
export const WARNING = 'warning'
export const REDIRECT = 'redirect'

export const RESET = 'reset'
export const NOTIFY = 'notify'
